import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { TranslocoModule } from "@ngneat/transloco";

export interface BillingPortalDialogData {
  url: string;
}

@Component({
  selector: "app-billing-portal-dialog",
  templateUrl: "./billing-portal-dialog.component.html",
  styleUrls: ["./billing-portal-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoModule]
})
export class BillingPortalDialogComponent {
  readonly safeUrl: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: BillingPortalDialogData,
    private dialogRef: MatDialogRef<BillingPortalDialogComponent>,
    sanitizer: DomSanitizer
  ) {
    this.safeUrl = sanitizer.bypassSecurityTrustResourceUrl(data.url);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
